import { useState } from 'react';

// Cambiar la versión cada vez que se publique un APK nuevo (evita que el navegador use uno viejo en caché)
const APK_VERSION = '1.0';
const APK_URL = `https://ticobaterias.com/uploads/descargas/TicoBaterias-Admin.apk?v=${APK_VERSION}`;
const PANEL_URL = 'https://admin.ticobaterias.com';

export default function Descargas() {
  const enApp = !!(window as any).Capacitor?.isNativePlatform?.();
  const esIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const [copiado, setCopiado] = useState('');

  const copiar = async (texto: string, cual: string) => {
    try {
      await navigator.clipboard.writeText(texto);
      setCopiado(cual);
      setTimeout(() => setCopiado(''), 2000);
    } catch { /* navegador sin permiso de portapapeles */ }
  };

  const whatsapp = (texto: string) =>
    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');

  const Paso = ({ n, children }: { n: number; children: any }) => (
    <li className="flex gap-3 items-start">
      <span className="flex-shrink-0 w-6 h-6 rounded-full bg-azul text-white text-xs font-bold flex items-center justify-center">{n}</span>
      <span className="text-sm text-gray-600 pt-0.5">{children}</span>
    </li>
  );

  const Compartir = ({ texto, url, id }: { texto: string; url: string; id: string }) => (
    <div className="flex gap-2 mb-5">
      <button onClick={() => whatsapp(`${texto}: ${url}`)}
        className="flex-1 bg-green-50 text-green-700 text-xs font-bold py-2 rounded-lg hover:bg-green-100">
        💬 Enviar por WhatsApp
      </button>
      <button onClick={() => copiar(url, id)}
        className="flex-1 bg-gray-100 text-gray-700 text-xs font-bold py-2 rounded-lg hover:bg-gray-200">
        {copiado === id ? '✓ Copiado' : '🔗 Copiar enlace'}
      </button>
    </div>
  );

  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold text-azul mb-1">📲 Descargas</h1>
      <p className="text-gray-500 text-sm mb-6">
        Instale el Panel Admin de TicoBaterías en su celular para administrar el sitio desde cualquier lugar.
      </p>

      {enApp && (
        <div className="bg-green-50 text-green-700 text-sm px-4 py-3 rounded-xl mb-6">
          ✓ Ya está usando la app de TicoBaterías Admin. Puede compartir los enlaces con otras personas desde aquí.
        </div>
      )}
      {esIOS && !enApp && (
        <div className="bg-blue-50 text-blue-800 text-sm px-4 py-3 rounded-xl mb-6">
          🍎 Está usando un <strong>iPhone o iPad</strong>: siga las instrucciones de la tarjeta <strong>App para iPhone</strong>.
        </div>
      )}

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        {/* ANDROID APK */}
        <div className="bg-white rounded-2xl shadow-sm p-6 flex flex-col">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-green-100 flex items-center justify-center text-2xl">🤖</div>
            <div>
              <h2 className="font-bold text-gray-800">App para Android</h2>
              <p className="text-xs text-gray-400">Versión {APK_VERSION} · Archivo APK</p>
            </div>
          </div>

          <a href={APK_URL} download="TicoBaterias-Admin.apk"
            className="bg-rojo text-white text-center font-bold text-sm py-3 rounded-xl hover:opacity-90 mb-2">
            ⬇️ Descargar APK
          </a>
          <Compartir texto="Descargue la app de TicoBaterías Admin" url={APK_URL} id="apk" />

          <h3 className="text-sm font-bold text-gray-700 mb-3">Cómo instalar</h3>
          <ol className="space-y-3">
            <Paso n={1}>Toque <strong>Descargar APK</strong> desde el celular.</Paso>
            <Paso n={2}>Abra el archivo descargado (en notificaciones o en la carpeta <em>Descargas</em>).</Paso>
            <Paso n={3}>Si el teléfono lo pide, active <strong>“Permitir de esta fuente”</strong> u <strong>“Orígenes desconocidos”</strong>.</Paso>
            <Paso n={4}>Toque <strong>Instalar</strong> y luego <strong>Abrir</strong>. Ingrese con su usuario del panel.</Paso>
          </ol>
          <p className="text-xs text-gray-400 mt-4">
            Para actualizar, descargue e instale el APK nuevo encima del anterior; no se pierde nada.
          </p>
        </div>

        {/* IPHONE */}
        <div className={`bg-white rounded-2xl shadow-sm p-6 flex flex-col ${esIOS && !enApp ? 'ring-2 ring-azul' : ''}`}>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center text-2xl">🍎</div>
            <div>
              <h2 className="font-bold text-gray-800">App para iPhone / iPad</h2>
              <p className="text-xs text-gray-400">Se instala desde Safari · Sin descargar archivos</p>
            </div>
          </div>

          <div className="bg-amber-50 text-amber-800 text-xs px-3 py-2 rounded-lg mb-4">
            ⚠️ El iPhone <strong>no permite instalar archivos APK</strong>. La app se agrega desde Safari y
            queda con su ícono en la pantalla de inicio, a pantalla completa, igual que una app normal.
          </div>

          <Compartir texto="Panel Admin de TicoBaterías (abrir en Safari)" url={PANEL_URL} id="ios" />

          <h3 className="text-sm font-bold text-gray-700 mb-3">Cómo instalar</h3>
          <ol className="space-y-3">
            <Paso n={1}>Abra <strong>Safari</strong> (el ícono de la brújula azul). <em>Debe ser Safari.</em></Paso>
            <Paso n={2}>Entre a <strong>admin.ticobaterias.com</strong>.</Paso>
            <Paso n={3}>Toque el botón <strong>Compartir</strong> (cuadro con flecha hacia arriba ⬆️). En iPhone está abajo al centro; en iPad, arriba a la derecha.</Paso>
            <Paso n={4}>Deslice hacia abajo y toque <strong>“Agregar a inicio”</strong>. Si no aparece, toque <em>“Editar acciones”</em> al final de la lista y actívelo.</Paso>
            <Paso n={5}>Deje el nombre <strong>TicoBaterías</strong> y toque <strong>Agregar</strong>.</Paso>
            <Paso n={6}>Abra la app desde el nuevo ícono en la pantalla de inicio e ingrese con su usuario.</Paso>
          </ol>
          <p className="text-xs text-gray-400 mt-4">
            No necesita actualizarse: siempre abre la versión más reciente del panel.
          </p>
        </div>

        {/* ANDROID NAVEGADOR */}
        <div className="bg-white rounded-2xl shadow-sm p-6 flex flex-col">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center text-2xl">🌐</div>
            <div>
              <h2 className="font-bold text-gray-800">Android sin APK</h2>
              <p className="text-xs text-gray-400">Instalar desde Chrome · Alternativa al APK</p>
            </div>
          </div>

          <Compartir texto="Panel Admin de TicoBaterías" url={PANEL_URL} id="pwa" />

          <h3 className="text-sm font-bold text-gray-700 mb-3">Cómo instalar</h3>
          <ol className="space-y-3">
            <Paso n={1}>Abra <strong>admin.ticobaterias.com</strong> en <strong>Chrome</strong>.</Paso>
            <Paso n={2}>Toque el menú <strong>⋮</strong> (arriba a la derecha).</Paso>
            <Paso n={3}>Elija <strong>“Instalar app”</strong> o <strong>“Agregar a pantalla principal”</strong>.</Paso>
            <Paso n={4}>Confirme y abra la app desde el nuevo ícono.</Paso>
          </ol>
          <p className="text-xs text-gray-400 mt-4">
            Útil si el teléfono no permite instalar APK. Siempre abre la versión más reciente.
          </p>
        </div>
      </div>
    </div>
  );
}
